import { cloneDeep } from 'lodash';

const limit = 20;

export default class ChangeLogService {
  /** @ngInject **/
  constructor(
    $http,
    cacheService,
    ngAuthSettings,
    moment,
    $q
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.cacheService = cacheService;
    this.moment = moment;
    this.limit = cloneDeep(limit);
    this.$q = $q;
  }
  
  getAccountChangelog(accountId, data) {
    const url = this._serviceUserBaseUrl(accountId);
    return this._handleChangelogApiRequest(url, data);
  }

  getAccountChangelogByObject(accountId, objectId, data) {
    const url = this._serviceUserBaseUrl(accountId) + '/object/' + objectId;
    return this._handleChangelogApiRequest(url, data);
  }

  getAccountChangelogByUsername(accountId, data) {
    const url = this._serviceUserBaseUrl(accountId) + '/user';
    return this._handleChangelogApiRequest(url, data);
  }

  getChangelogRequestLimit() {
    return limit;
  }

  _handleChangelogApiRequest(url, data) {
    const cacheKey = this._getCacheKey(url, data);

    if (this.cacheService.get(cacheKey)) {
      return this.$q.when(this.cacheService.get(cacheKey));
    }
    const ref = this;
    return this.$http.post(url, data).then((response) => {
      return ref._handleChangelogResponse(response, cacheKey);
    });
  }

  _handleChangelogResponse(response, cacheKey) {
    let logs = response.data.changeLog && angular.copy(response.data.changeLog.changeLog);
      
    if (logs) {
      logs = logs.filter((log) => {
        return log.action !== 'Update' || log.diff;
      });
    }

    const returnData = {
      logs: logs || [],
      checkMoreLogs: response.data.changeLog && response.data.changeLog.changeLog.length >= limit,
      endDateForNextRequest: (logs && logs.length && this.moment(logs[logs.length - 1].dtStamp)) || null 
    };

    if (cacheKey) {
      this.cacheService.set(cacheKey, returnData, {
        expireAfterSeconds: 60,
        persistence: false
      });
    }

    return returnData;
  }

  _getCacheKey(url, data) {
    return url + '-firstRequest=' + (data.end ? data.end : 'start') + (data.userName ? '-user=' + data.userName : '');
  }

  _serviceUserBaseUrl(accountId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/changelog';
  }
}